import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import MaskTelefone from '../util/SimpleMask/MaskTelefone';
import MaskCelular from '../util/SimpleMask/MaskCelular';

import { useDispatch, useSelector } from 'react-redux'

export default function ContatoForm() {
    const dispatch = useDispatch();

    const contato = useSelector(state => state.contato)

    function maskTelefone(e) {
        let v = e.target.value
        v = MaskTelefone(v)
        setNumTelefone(v);
    }

    function maskCelular(e) {
        let v = e.target.value
        v = MaskCelular(v)
        setNumCelular(v);
    }

    function setNumTelefone(e) {
        const numTelefone = e
        dispatch({ type: 'SET_NUM_TELEFONE', numTelefone: numTelefone })
    }
    function setNumCelular(e) {
        const numCelular = e
        dispatch({ type: 'SET_NUM_CELULAR', numCelular: numCelular })
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Telefone"
                    name="telefone"
                    id="telefone"
                    onChange={(e) => maskTelefone(e)}
                    value={contato.numTelefone}
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    fullWidth
                    variant="outlined"
                    label="Celular"
                    name="celular"
                    id="celular"
                    onChange={(e) => maskCelular(e)}
                    value={contato.numCelular}
                />
            </Grid>
        </Grid>
    );
}